export default __webpack_public_path__ + "static/media/digitalLabImage.16deb0cd.png";